<template>
  <div class="transfer">
    <v-app>
      <div v-if="!userid">
        <v-container>
          <v-alert :value="true" color="warning" icon="priority_high" outline>
            {{ $t('Not found this page') }}
          </v-alert>
        </v-container>
      </div>
      <div v-else-if="isCompleted">
        <cover>
          <div slot="body" style="text-align: center; margin-top: -95px">
            <img
              src="@/assets/img/ecommerce/shopping_cart@4x.png"
              alt="shopping cart"
              style="width: 140px; padding-bottom: 10px"
            />
            <p style="padding-bottom: 10px">{{ $t('Payment Successfully') }}</p>
            <v-btn outline :color="theme.color" @click="goToShop()">
              {{ $t('Continue Shopping') }}
            </v-btn>
          </div>
        </cover>
      </div>
      <!-- <div v-else-if="isEmptyShoppingCart">
        <cover>
          <div slot="body" style="margin-left: -93px;text-align: center;margin-top: -95px;">
            <img
              src="../assets/img/ecommerce/empty_shopping_cart@4x.png"
              alt="empty shopping cart"
              style="width: 140px;padding-bottom: 10px;"
            >
            <p style="padding-bottom: 10px">{{$t('There are no items in this cart')}}</p>
            <v-btn
              outline
              :color="theme.color"
              @click="goToShop()"
            >{{$t('Continue Shopping')}}</v-btn>
          </div>
        </cover>
      </div>-->
      <div v-else-if="isEmptyShoppingCart">
        <cover>
          <div slot="body" style="text-align: center; margin-top: -95px">
            <img
              src="@/assets/img/ecommerce/shopping_cart_out@4x.png"
              alt="empty shopping cart"
              style="width: 140px; padding-bottom: 10px"
            />
            <p style="padding-bottom: 10px">
              {{ $t('This order has been reset, please try to order again.') }}
            </p>

            <v-btn outline :color="theme.color" @click="goToShop()">
              {{ $t('Continue Shopping') }}
            </v-btn>
          </div>
        </cover>
      </div>
      <!-- <div v-else-if="pageLoading" style="height: 100vh">
        <v-layout justify-center align-center style="height: 100%">
          <v-progress-circular
            :key="theme.color"
            :size="70"
            :width="7"
            :color="theme.color"
            indeterminate
          ></v-progress-circular>
        </v-layout>
      </div>-->
      <div v-else>
        <merchant-detail v-model="pageProfile"></merchant-detail>

        <form
          id="checkout-form"
          class="checkout-form"
          method="POST"
          @submit.prevent="handleSubmit"
        >
          <v-container class="mt-5">
            <v-layout wrap row>
              <v-flex xs12 sm6 offset-sm3>
                <h3 class="headline" :style="{ color: theme.color }">
                  {{ $t('Payment') }}
                </h3>

                <br />
              </v-flex>
              <v-flex xs12 sm6 offset-sm3>
                <div
                  :class="{ 'has-error': errors.has('customerName') }"
                  class="mb-1"
                >
                  <v-text-field
                    :label="$t('Name')"
                    :data-vv-as="$t('Name')"
                    outline
                    name="customerName"
                    v-validate="'required'"
                    v-model="customerName"
                    light
                    :color="theme.color"
                    :error="errors.has('customerName') ? true : false"
                    :error-messages="
                      errors.has('customerName')
                        ? errors.first('customerName')
                        : ''
                    "
                  ></v-text-field>
                </div>
                <v-layout>
                  <v-flex class="pa-1">
                    <v-btn
                      :color="
                        chooseShippingType == 'delivery' ? theme.color : 'grey'
                      "
                      depressed
                      :outline="chooseShippingType != 'delivery'"
                      block
                      dark
                      @click="chooseShippingType = 'delivery'"
                    >
                      จัดส่งสินค้า
                    </v-btn>
                  </v-flex>
                  <v-flex class="pa-1">
                    <v-btn
                      :color="
                        chooseShippingType == 'pickup' ? theme.color : 'grey'
                      "
                      depressed
                      :outline="chooseShippingType != 'pickup'"
                      block
                      dark
                      @click="chooseShippingType = 'pickup'"
                    >
                      รับที่ร้าน
                    </v-btn>
                  </v-flex>
                </v-layout>
                <template v-if="chooseShippingType == 'delivery'">
                  <div
                    :class="{ 'has-error': errors.has('shippingAddress') }"
                    class="mb-1"
                  >
                    <div class="mb-3">
                      <div
                        :class="{ 'has-error': errors.has('ปักหมุดที่อยู่') }"
                        class="mb-1"
                      >
                        <gmap-address
                          v-if="showmap"
                          :placesinfo="placesinfolabel"
                          v-validate="{ required: true }"
                          name="ปักหมุดที่อยู่"
                          v-model="gmapvalue"
                          v-on:input="gmapLocation"
                          :lastordercoords="lastordercoords"
                          :error="errors.has('ปักหมุดที่อยู่')"
                          :shoplocation="branchlocation"
                          :radius="3300"
                        ></gmap-address>
                        <p
                          class="caption ma-2"
                          style="color: red"
                          v-show="errors.has('ปักหมุดที่อยู่')"
                        >
                          {{ errors.first('ปักหมุดที่อยู่') }}
                        </p>
                      </div>
                    </div>
                    <v-textarea
                      outline
                      :label="$t('Shipping Address')"
                      :placeholder="
                        $t('Ex. Address No., Village, Alley, and Road')
                      "
                      name="shippingAddress"
                      rows="5"
                      :data-vv-as="$t('Shipping Address')"
                      style="resize: none; width: 100%"
                      v-model="shippingAddress"
                      v-validate="{
                        required: true,
                        regex: /([^0-9][1-9][0-9]{4})|^([1-9][0-9]{4})/,
                        isBearhousezipcode: [cart.length, isBearhouse]
                      }"
                      light
                      :color="theme.color"
                      :error="errors.has('shippingAddress') ? true : false"
                      :error-messages="
                        errors.has('shippingAddress')
                          ? errors.first('shippingAddress')
                          : ''
                      "
                    ></v-textarea>
                  </div>
                </template>

                <div
                  :class="{ 'has-error': errors.has('customerPhone') }"
                  class="mb-1"
                >
                  <v-text-field
                    :label="$t('Tel.')"
                    :data-vv-as="$t('Tel.')"
                    outline
                    tyle="tel"
                    name="customerPhone"
                    light
                    :color="theme.color"
                    v-validate="{
                      required: true,
                      regex:
                        /((\(?(\+\s*)([0-9]{2,3})\)?\s*[0]?)|[0])(([1-9][0-9]?))\s*\-?\s*([0-9]{3})\s*\-?\s*([0-9]{4,5})/
                    }"
                    v-model="customerPhone"
                    :error="errors.has('customerPhone') ? true : false"
                    :error-messages="
                      errors.has('customerPhone')
                        ? errors.first('customerPhone')
                        : ''
                    "
                  ></v-text-field>
                </div>

                <template
                  v-if="
                    pageProfile && pageProfile.pageid && shippinglist && !isOoca
                  "
                >
                  <shipping-type
                    v-show="false"
                    :bearhouseshippingprice="bearhouseshippingprice"
                    v-model="shippingType"
                    :shippinglist="shippinglist"
                    :additionalproduct_charge="additionalproduct_charge"
                    :pageid="pageProfile.pageid"
                    :total="totalincludediscount"
                  ></shipping-type>
                </template>
              </v-flex>
            </v-layout>
          </v-container>
          <v-divider></v-divider>
          <v-container class="mt-3">
            <v-layout wrap row>
              <v-flex xs12 sm6 offset-sm3>
                <h3 class="headline mb-3" :style="{ color: theme.color }">
                  {{ $t('Payment Detail') }}
                </h3>

                <cart-summary
                  :isCustomize="true"
                  :customerShippingPrice="customShippingPrice"
                  :total="total"
                  :totalincludediscount="totalincludediscount"
                  :shippingType="shippingType"
                  :additionalproduct_charge="additionalproduct_charge"
                  :discount="discount"
                  :ableToBuy="ableToBuy"
                  :voucher="voucher"
                ></cart-summary>

                <template
                  v-if="
                    !loading &&
                    hasVoucher &&
                    !['485851741439218'].includes(pageProfile.pageid)
                  "
                >
                  <voucher-code-input
                    v-model="voucherCode"
                    @onUpdateTotal="onUpdateTotal"
                  ></voucher-code-input>
                </template>

                <div>
                  <div class="mb-4">
                    <template v-if="banktransferinfo_photo">
                      <img
                        :src="banktransferinfo_photo"
                        alt="bank transfer"
                        style="
                          border: 1px solid #eee;
                          border-radius: 5px;
                          margin-bottom: 15px;
                          width: 100%;
                        "
                      />
                    </template>
                    <template v-if="banktransferinfo">
                      <bank-number :text="banktransferinfo"></bank-number>
                    </template>
                    <!-- <bank-number
                      :text="
                        `กรุณาโอนเงินมาที่\nธนาคาร: ${
                          khaiwhanselectedbank.bankname
                        } \nเลขที่บัญชี: ${
                          khaiwhanselectedbank.banknum
                        } <<กดตรงนี้เพื่อ copy\nชื่อบัญชี: ${
                          khaiwhanselectedbank.bankowner
                        }`
                      "
                    ></bank-number> -->
                  </div>

                  <div
                    :class="{ 'has-error': errors.has('paymentSlipImage') }"
                    class="mb-4"
                    v-if="
                      !shippingType ||
                      (shippingType && shippingType.type != 'cod_charge')
                    "
                  >
                    <h3 class="headline" :style="{ color: theme.color }">
                      {{ $t('Payment slip') }}
                    </h3>
                    <br />

                    <upload-file
                      name="paymentSlipImage"
                      v-validate="'required'"
                      :data-vv-as="$t('Payment Slip Image')"
                      v-model="paymentSlipImage"
                    ></upload-file>
                    <p
                      class="caption ma-2"
                      style="color: red"
                      v-show="errors.has('paymentSlipImage')"
                    >
                      {{ errors.first('paymentSlipImage') }}
                    </p>
                  </div>
                </div>

                <div
                  :class="{ 'has-error': errors.has('remark') }"
                  style="margin-bottom: 15px"
                >
                  <v-textarea
                    outline
                    :label="$t('กรอกรหัสสมาชิก')"
                    name="remark"
                    rows="5"
                    :data-vv-as="$t('กรอกรหัสสมาชิก')"
                    style="resize: none; width: 100%"
                    v-model="remark"
                    :color="theme.color"
                    light
                  ></v-textarea>
                </div>
                <div>
                  <div
                    v-if="
                      pageProfile.fbpay_status ||
                      (pageProfile.gbprime_status && !isOoca)
                    "
                    style="padding-bottom: 25px"
                  >
                    <v-card>
                      <v-card-text>
                        <v-layout row wrap class="mb-3">
                          <v-flex class="pr-1" v-if="pageProfile.fbpay_status">
                            <v-btn
                              :color="theme.color"
                              dark
                              small
                              block
                              @click="transferType = 'fbpay'"
                              :outline="transferType != 'fbpay'"
                            >
                              <v-icon small class="mr-2"
                                >mdi-facebook-messenger</v-icon
                              >
                              {{ $t('Mobile Banking') }}
                            </v-btn>
                            <div
                              class="text-xs-center"
                              :style="{ color: theme.color }"
                            >
                              <!-- (รวดเร็วกว่า) -->
                            </div>
                          </v-flex>
                          <v-flex
                            class="pr-1"
                            v-if="pageProfile.gbprime_status"
                          >
                            <v-btn
                              :color="theme.color"
                              dark
                              block
                              small
                              @click="transferType = 'qrcode'"
                              :outline="transferType != 'qrcode'"
                            >
                              <v-icon small class="mr-2">mdi-qrcode-scan</v-icon
                              >QR CODE
                            </v-btn>
                            <div
                              class="text-xs-center"
                              :style="{ color: theme.color }"
                            >
                              <!-- (รวดเร็วกว่า) -->
                            </div>
                          </v-flex>
                          <v-flex>
                            <v-btn
                              :color="theme.color"
                              dark
                              block
                              small
                              @click="transferType = 'transfer'"
                              :outline="transferType != 'transfer'"
                            >
                              <v-icon small class="mr-2"
                                >mdi-cash-multiple</v-icon
                              >
                              {{ $t('transfer') }}
                            </v-btn>
                          </v-flex>
                        </v-layout>

                        <template
                          v-if="['transfer', 'fbpay'].includes(transferType)"
                        >
                          <div v-if="['transfer'].includes(transferType)">
                            <div class="mb-4">
                              <template v-if="banktransferinfo_photo">
                                <img
                                  :src="banktransferinfo_photo"
                                  alt="bank transfer"
                                  style="
                                    border: 1px solid #eee;
                                    border-radius: 5px;
                                    margin-bottom: 15px;
                                    width: 100%;
                                  "
                                />
                              </template>
                              <template v-if="banktransferinfo">
                                <bank-number
                                  :text="banktransferinfo"
                                ></bank-number>
                              </template>
                            </div>

                            <div
                              :class="{
                                'has-error': errors.has('paymentSlipImage')
                              }"
                              class="mb-4"
                              v-if="
                                !shippingType ||
                                (shippingType &&
                                  shippingType.type != 'cod_charge')
                              "
                            >
                              <h3
                                class="headline"
                                :style="{ color: theme.color }"
                              >
                                {{ $t('Payment slip') }}
                              </h3>
                              <br />

                              <upload-file
                                name="paymentSlipImage"
                                v-validate="'required'"
                                :data-vv-as="$t('Payment Slip Image')"
                                v-model="paymentSlipImage"
                              ></upload-file>
                              <p
                                class="caption ma-2"
                                style="color: red"
                                v-show="errors.has('paymentSlipImage')"
                              >
                                {{ errors.first('paymentSlipImage') }}
                              </p>
                            </div>
                          </div>

                          <div
                            class="text-xs-center"
                            style="padding-top: 15px; padding-bottom: 15px"
                          >
                            <a
                              href="javascript:void(0);"
                              @click="openModal()"
                              style="color: rgb(169, 169, 169)"
                            >
                              {{
                                $t('By clicking Proceed Payment, Ive read and')
                              }}
                              <br />
                              {{ $t('agree to') }}
                              <span :style="{ color: theme.color }">
                                {{
                                  $t('Terms & Condition & Refund Prolicy')
                                }} </span
                              >.
                            </a>
                          </div>
                          <p
                            class="text-xs-center"
                            style="color: red"
                            v-if="isEmptyShoppingCart"
                          >
                            {{
                              $t(
                                'Not enough products in stock, please try to order again.'
                              )
                            }}.
                          </p>
                          <div class="text-xs-center">
                            <v-btn
                              dark
                              :color="theme.color"
                              :disabled="loading || isEmptyShoppingCart"
                              @click="handleSubmit"
                              :loading="pageLoading"
                            >
                              <v-icon class="mr-2">mdi-cart-outline</v-icon>
                              {{ $t('Proceed Payment') }}
                            </v-btn>
                          </div>
                        </template>
                        <template v-else>
                          <div
                            class="text-xs-center"
                            style="padding-top: 15px; padding-bottom: 15px"
                          >
                            <a
                              href="javascript:void(0);"
                              @click="openModal()"
                              style="color: rgb(169, 169, 169)"
                            >
                              {{
                                $t('By clicking Proceed Payment, Ive read and')
                              }}
                              <br />
                              {{ $t('agree to') }}
                              <span :style="{ color: theme.color }">
                                {{
                                  $t('Terms & Condition & Refund Prolicy')
                                }} </span
                              >.
                            </a>
                          </div>
                          <p
                            class="text-xs-center"
                            style="color: red"
                            v-if="isEmptyShoppingCart"
                          >
                            {{
                              $t(
                                'Not enough products in stock, please try to order again.'
                              )
                            }}.
                          </p>
                          <p
                            v-else-if="!ableToBuy"
                            style="color: red"
                            class="text-xs-center"
                          >
                            ไม่สามารถจัดส่งนอกพื้นที่ได้
                          </p>

                          <div v-else class="text-xs-center">
                            <v-btn
                              dark
                              :color="theme.color"
                              :disabled="loading || isEmptyShoppingCart"
                              @click="qrHandleSubmit"
                              :loading="pageLoading"
                            >
                              <v-icon class="mr-2">mdi-cart-outline</v-icon>
                              {{ $t('Proceed Payment') }}
                            </v-btn>
                          </div>
                        </template>
                      </v-card-text>
                    </v-card>
                  </div>

                  <div
                    v-if="
                      !(pageProfile.fbpay_status || pageProfile.gbprime_status)
                    "
                    class="text-xs-center"
                    style="padding-bottom: 25px"
                  >
                    <div style="padding-top: 15px; padding-bottom: 15px">
                      <a
                        href="javascript:void(0);"
                        @click="openModal()"
                        style="color: rgb(169, 169, 169)"
                      >
                        {{ $t('By clicking Proceed Payment, Ive read and') }}
                        <br />
                        {{ $t('agree to') }}
                        <span :style="{ color: theme.color }">
                          {{ $t('Terms & Condition & Refund Prolicy') }} </span
                        >.
                      </a>
                    </div>
                    <p
                      class="text-xs-center"
                      style="color: red"
                      v-if="isEmptyShoppingCart"
                    >
                      {{
                        $t(
                          'Not enough products in stock, please try to order again.'
                        )
                      }}.
                    </p>
                    <p
                      v-else-if="!ableToBuy"
                      style="color: red"
                      class="text-xs-center"
                    >
                      ไม่สามารถจัดส่งนอกพื้นที่ได้
                    </p>
                    <v-btn
                      dark
                      v-else
                      :color="theme.color"
                      :disabled="loading || isEmptyShoppingCart"
                      @click="handleSubmit"
                      :loading="pageLoading"
                    >
                      <v-icon class="mr-2">mdi-cart-outline</v-icon>
                      {{ $t('Proceed Payment') }}
                    </v-btn>
                  </div>
                </div>
              </v-flex>
            </v-layout>
          </v-container>
        </form>
      </div>
    </v-app>
    <Loading v-if="!pageLoading && loading"></Loading>
    <term-and-condition v-if="showTerm" @close="close()"></term-and-condition>
    <v-dialog v-model="showQrCode" max-width="376" persistent>
      <v-card>
        <div class="text-xs-right">
          <v-btn fab small flat @click="showQrCode = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
        <v-card-text>
          <template v-if="qrimage">
            <img :src="qrimage" style="width: 100%" />
            <div class="text-xs-center">
              <div>
                กรุณาจ่ายเงินภายใน
                <span :style="{ color: theme.color }">{{ timer }}</span> วินาที
                <br />หากแสกนแล้วโปรดรอซักครู่ <br />ติดปัญหากรุณาติดต่อแอดมิน
              </div>
            </div>
          </template>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import $ from 'jquery'
import config from '@/config'
import axios from 'axios'
import nl2br from 'vue-nl2br'
import SyncLoader from 'vue-spinner/src/SyncLoader.vue'

import Loading from '@/components/Loading.vue'
import Modal from '@/components/Modal.vue'
import Cover from '@/components/Cover.vue'
import UploadFile from '@/components/UploadFile.vue'
import TermAndCondition from '@/components/ecommerce/TermAndCondition.vue'
import MerchantDetail from '@/components/ecommerce/MerchantDetail'
import CartItem from '@/components/payment/CartItem.vue'
import BankNumber from '@/components/BankNumber.vue'
import ShippingType from '@/components/ecommerce/ShippingType.vue'
import CartSummary from '@/components/ecommerce/CartSummary.vue'
import GmapAddress from '@/components/ecommerce/GmapAddress.vue'
import { bearhousecalculateshippingprice } from '@/assets/js/BearHouse.js'
import moment from 'moment'
import numeral from 'numeral'
import VoucherCodeInput from '@/components/ecommerce/VoucherCodeInput'

const dict = {
  en: {
    custom: {
      shippingAddress: {
        isBearhousezipcode: 'Wrong shipping address'
      }
    }
  },
  th: {
    custom: {
      shippingAddress: {
        isBearhousezipcode: 'ที่อยู่จัดส่งไม่ถูกต้อง'
      }
    }
  },
  la: {
    custom: {
      shippingAddress: {
        isBearhousezipcode: 'ที่อยู่จัดส่งไม่ถูกต้อง'
      }
    }
  }
}

export default {
  data() {
    return {
      loadingVoucher: true,
      voucherCode: null,
      voucher: null,
      timestamp: moment().format('x'),
      app: 'facebook',
      khaiwhandistance: null,
      lastordercoords: null,
      gmapvalue: null,
      pageid: null,
      userid: null,
      paiddate: null,
      paidtime: null,
      products: {},
      remark: '',
      transferType: '',
      khaiwhanshippingprice: 0,
      khaiwhanbank: [
        {
          ref: 'ไข่หวานบ้านซูชิ สาขาสัมมากร',
          bankname: 'ธนาคารกสิกรไทย',
          banknum: '060-3-98886-8',
          bankowner: 'บจก. พีเอสเค. แพลนเนท'
        },
        {
          ref: 'ไข่หวานบ้านซูชิ สาขาราชพฤกษ์',
          bankname: 'ธนาคารกสิกรไทย',
          banknum: '062-8-36593-8',
          bankowner: 'บจก. พีเอสเค. แพลนเนท'
        },
        {
          ref: 'ไข่หวานบ้านซูชิ สาขาบางใหญ่',
          bankname: 'ธนาคารกสิกรไทย',
          banknum: '062-3-42531-2',
          bankowner: 'บจก. ดับเบิ้ลยูพีสมาร์ทกรุ๊ป'
        }
      ],

      additionalproduct_charge: 0,
      ems_charge: 0,
      normal_charge: 0,
      kerry_charge: 0,
      total: 0,
      totalincludediscount: 0,
      discount: 0,

      shippingType: undefined,

      loading: false,
      pageLoading: true,
      khaiwhanselectedbank: {
        bankname: '',
        banknum: '',
        bankowner: ''
      },
      isCompleted: false,
      isEmptyShoppingCart: false,

      shippingAddress: null,
      showAlert: false,
      showProduct: false,
      shippinglist: undefined,
      showQrCode: false,
      qrimage: '',
      intervalQrCode: null,
      timer: 300,
      isRequest: true,
      referenceNo: '',

      config: {
        color: config.color
      },
      placesinfo: '',
      sessiontoken: null,
      banktransferinfo: null,
      banktransferinfo_photo: null,
      mainBankTransferInfoPhoto: null,
      paymentSlipImage: null,
      branchlocation: '',

      showTerm: false,
      customerName: null,
      customerPhone: null,
      showmap: false,
      chooseShippingType: 'delivery',
      ableToShipping: false,
      pickuplocation: null,
      hasVoucher: false
    }
  },
  mounted: async function () {
    let vm = this

    vm.$validator.localize(dict)
    vm.$validator.localize(this.currentLang)

    vm.loading = true

    if (vm.$route.query.userid) {
      vm.userid = vm.$route.query.userid
    }

    if (vm.$route.query.pkey) {
      vm.omise_key = vm.$route.query.pkey
    }

    if (vm.$route.query.app) {
      vm.app = vm.$route.query.app
    }

    if (vm.$route.query.sessiontoken) {
      vm.sessiontoken = vm.$route.query.sessiontoken
    }
    vm.pageLoading = true

    vm.pageid = vm.pageProfile.pageid

    if (vm.pageProfile.fbpay_status) {
      vm.transferType = 'fbpay'
    } else if (vm.pageProfile.gbprime_status) {
      vm.transferType = 'qrcode'
    } else {
      vm.transferType = 'transfer'
    }

    document.title = vm.pageProfile.pagename
    vm.$store.dispatch('updateShopColor', vm.pageProfile.shopcolor)
    // await vm.checkpageusepromocode();
    vm.hasVoucher = vm.pageProfile.ispromocode
    vm.pageLoading = false

    if (vm.userid) {
      try {
        let firstletterofuserid = vm.userid.charAt(0)
        if (firstletterofuserid && firstletterofuserid.toLowerCase() == 'u') {
          vm.app = 'line'
        }
      } catch (error) {
        // eslint-disable-next-line
        console.error(error)
      }

      // var response_lang = await vm.$store.dispatch("getUserShopLang", {
      //   pageid: vm.pageProfile.pageid,
      //   userid: vm.userid,
      // });
      // if (response_lang) {
      //   vm.$store.dispatch("setLang", response_lang.usershoplang);
      // }
      vm.$store.dispatch('setLang', vm.pageProfile.shoplang)

      vm.getUserDetail().then(function (data) {
        vm.customerName = data.name
        vm.customerPhone = data.phone
        if (data.address) {
          var gmapregex =
            /https\:\/\/www\.google\.com\/maps\?\=(\d)+(\.(\d)+)?\,(\d)+(\.(\d)+)?/gm
          var address = data.address.replace(gmapregex, '').replace('\n', '')
          vm.shippingAddress = address
        }
      })

      // var data = {
      //   userid: vm.userid,
      //   pageid: vm.pageProfile.pageid,
      //   lang: vm.currentLang
      // };
      // vm.$store.dispatch("setLang", vm.currentLang);
      // vm.$store.dispatch("updatePageProfile", data);
    }
    vm.$store
      .dispatch('getWholeSaleStatus', vm.pageProfile.pageid)
      .then(function () {
        vm.$store.dispatch('getWholeSale', vm.pageProfile.pageid)
      })
    await vm.getProducts()
    vm.loadingVoucher = true
    await vm.getUserCart()
    await vm.$nextTick()
    vm.loadingVoucher = false
    await vm.getbranchlocation()
    // await vm.getTransferDetail();
    vm.loading = false
  },
  components: {
    SyncLoader,
    Loading,
    Modal,
    Cover,
    MerchantDetail,
    nl2br,
    UploadFile,
    TermAndCondition,
    CartItem,
    BankNumber,
    ShippingType,
    CartSummary,
    GmapAddress,
    VoucherCodeInput
  },
  computed: {
    ...mapGetters({
      cart: 'getCart',
      currentLang: 'currentLang',
      loadingPageProfile: 'getLoadingPageProfile',
      pageProfile: 'getPageProfile',
      theme: 'getTheme'
    }),

    placesinfolabel() {
      // placesinfo, distance, ableToBuy, shippingPrice

      return this.getplaceInfo(
        this.placesinfo,
        this.khaiwhandistance ? this.khaiwhandistance.distance : 0,
        this.ableToShipping,
        this.customShippingPrice
      )
    },
    bearhouseshippingprice() {
      var zipcode = ''
      if (
        this.shippingAddress &&
        this.shippingAddress.match(/([1-9][0-9]{4})|^([1-9][0-9]{4})/g)
      ) {
        zipcode = this.shippingAddress
          .match(/([^0-9][1-9][0-9]{4})|^([1-9][0-9]{4})/g)[0]
          .trim()
      }
      return bearhousecalculateshippingprice(zipcode, this.cart.length)
    },
    isBearhouse() {
      return (
        this.pageProfile &&
        this.$store.state.bearhouse.includes(this.pageProfile.pageid)
      )
    },
    isOoca() {
      return (
        this.pageProfile &&
        ['100935418246290', '142088386194745'].includes(this.pageProfile.pageid)
      )
    },
    pagename: function () {
      return this.$route.query.pageid
        ? this.$route.query.pageid
        : this.$route.params.id
        ? this.$route.params.id
        : undefined
    },
    isGaiGao() {
      return this.pageProfile && this.pageProfile.type == 'gaigao'
    },
    totalPrice: function () {
      var total = this.totalincludediscount
      var shippingPrice = 0

      if (this.isBearhouse) {
        shippingPrice =
          this.bearhouseshippingprice + this.additionalproduct_charge
      } else if (this.isGaiGao) {
        shippingPrice = this.customShippingPrice + this.additionalproduct_charge
      } else if (this.shippingType) {
        shippingPrice = this.shippingType.value + this.additionalproduct_charge
      } else {
        shippingPrice = this.additionalproduct_charge
      }

      if (shippingPrice && this.voucher) {
        if (this.voucher.freeship) {
          shippingPrice = 0
        } else if (shippingPrice > this.voucher.discountship) {
          shippingPrice = shippingPrice - this.voucher.discountship
        } else {
          shippingPrice = 0
        }
      }

      return total + shippingPrice
    },
    isCartOutOfStock: function () {
      return (
        this.cart.filter(function (el) {
          if (el.optionDetail == null) {
            return true
          }
          if (parseInt(el.optionDetail[2]) < el.quantity) {
            return true
          }
          return false
        }).length > 0
      )
    },
    ableToBuy() {
      if (this.chooseShippingType == 'delivery') {
        return this.ableToShipping
      } else {
        return true
      }
    },
    customShippingPrice() {
      if (this.chooseShippingType == 'delivery') {
        return this.khaiwhanshippingprice
      } else {
        return 0
      }
    }
  },
  methods: {
    async checkpageusepromocode() {
      var response = await axios.get(
        config.getConfig('serverUrl') + `checkpageusepromocode`,
        {
          params: {
            pageid: this.pageProfile.pageid
          }
        }
      )

      if (response.status == 200 && response.data.data) this.hasVoucher = true
    },
    onUpdateTotal: async function (payload) {
      this.voucher = payload
      this.loadingVoucher = true
      await this.getUserCart()
      this.loadingVoucher = false
    },
    getbranchlocation() {
      var vm = this
      return new Promise((resolve, reject) => {
        axios
          .get(
            config.getConfig('serverUrl') +
              'branchlocation?pageid=' +
              this.pageid
          )
          .then((response) => {
            if (response.data.responsecode == 200) {
              vm.branchlocation = response.data.branchlocation
              let externalScript = document.createElement('script')
              externalScript.setAttribute(
                'src',
                `https://maps.googleapis.com/maps/api/js?key=${response.data.googlekey}&language=th&libraries=places`
              )
              externalScript.async = true
              externalScript.defer = true
              externalScript.onload = () => {
                vm.showmap = true
                resolve()
              }
              document.head.appendChild(externalScript)
              // resolve();
            }
          })
      })
    },
    calshippingpricekaiwan(distance_km, totalprice) {
      //   var ceiling_distance_km = Math.ceil(distance_km);
      //
      try {
        var ceiling_distance_km = 0
        // var decimal = parseFloat((distance_km % 1).toFixed(1));
        // distance_km = Math.floor(distance_km);
        // if (decimal > 0.4) distance_km += 1;
        ceiling_distance_km = distance_km.toFixed(2)
      } catch (error) {
        return false
      }

      var price = 0
      if (this.pageProfile.pageid == '100160834719075') {
        if (ceiling_distance_km >= 0 && ceiling_distance_km <= 0.15) {
          price = 0
        } else if (ceiling_distance_km >= 0.16 && ceiling_distance_km <= 1.9) {
          price = 25
        } else if (ceiling_distance_km >= 2 && ceiling_distance_km <= 2.4) {
          price = 30
        } else if (ceiling_distance_km >= 2.5 && ceiling_distance_km <= 2.9) {
          price = 35
        } else if (ceiling_distance_km >= 3 && ceiling_distance_km <= 3.4) {
          price = 42
        } else if (ceiling_distance_km >= 3.5 && ceiling_distance_km <= 3.9) {
          price = 52
        } else if (ceiling_distance_km >= 4 && ceiling_distance_km <= 4.4) {
          price = 62
        } else if (ceiling_distance_km >= 4.5 && ceiling_distance_km <= 4.9) {
          price = 72
        } else if (ceiling_distance_km >= 5 && ceiling_distance_km <= 5.4) {
          price = 82
        } else if (ceiling_distance_km >= 5.5 && ceiling_distance_km <= 5.9) {
          price = 92
        } else if (ceiling_distance_km >= 6 && ceiling_distance_km <= 6.5) {
          price = 92
        } else {
          price = false
        }
      } else if (this.pageProfile.pageid == '109008520721534') {
        if (ceiling_distance_km >= 0 && ceiling_distance_km <= 0.15) {
          price = 0
        } else if (ceiling_distance_km >= 0.16 && ceiling_distance_km <= 1.9) {
          price = 25
        } else if (ceiling_distance_km >= 2 && ceiling_distance_km <= 2.4) {
          price = 30
        } else if (ceiling_distance_km >= 2.5 && ceiling_distance_km <= 2.9) {
          price = 35
        } else if (ceiling_distance_km >= 3 && ceiling_distance_km <= 3.4) {
          price = 42
        } else if (ceiling_distance_km >= 3.5 && ceiling_distance_km <= 3.9) {
          price = 52
        } else {
          price = false
        }
      } else {
        if (ceiling_distance_km >= 0 && ceiling_distance_km <= 0.15) {
          price = 0
        } else if (ceiling_distance_km >= 0.16 && ceiling_distance_km <= 1.9) {
          price = 25
        } else if (ceiling_distance_km >= 2 && ceiling_distance_km <= 2.4) {
          price = 30
        } else if (ceiling_distance_km >= 2.5 && ceiling_distance_km <= 2.9) {
          price = 35
        } else if (ceiling_distance_km >= 3 && ceiling_distance_km <= 3.4) {
          price = 42
        } else if (ceiling_distance_km >= 3.5 && ceiling_distance_km <= 3.9) {
          price = 52
        } else if (ceiling_distance_km >= 4 && ceiling_distance_km <= 4.4) {
          price = 62
        } else if (ceiling_distance_km >= 4.5 && ceiling_distance_km <= 4.9) {
          price = 72
        } else if (ceiling_distance_km >= 5 && ceiling_distance_km <= 5.4) {
          price = 82
        } else if (ceiling_distance_km >= 5.5 && ceiling_distance_km <= 5.9) {
          price = 92
        } else if (ceiling_distance_km >= 6 && ceiling_distance_km <= 6.5) {
          price = 102
        } else {
          price = false
        }
      }

      // try {
      //   var ceiling_distance_km = 0;
      //   var decimal = parseFloat((distance_km % 1).toFixed(1));
      //   distance_km = Math.floor(distance_km);
      //   if (decimal > 0.4) distance_km += 1;
      //   ceiling_distance_km += distance_km;
      // } catch (error) {
      //   return false;
      // }

      // var price = 0;
      // switch (ceiling_distance_km) {
      //   case 0:
      //   case 1:
      //   case 2:
      //     price = 25;
      //     break;
      //   case 3:
      //     price = 30;
      //     break;
      //   case 4:
      //   case 5:
      //     price = 35;
      //     break;
      //   case 6:
      //     price = 45;
      //     break;
      //   case 7:
      //     price = 55;
      //     break;
      //   case 8:
      //     price = 65;
      //     break;
      //   case 9:
      //     price = 75;
      //     break;
      //   case 10:
      //     price = 85;
      //     break;
      //   case 11:
      //     price = 95;
      //     break;
      //   case 12:
      //     price = 105;
      //     break;
      //   case 13:
      //     price = 115;
      //     break;
      //   case 14:
      //     price = 125;
      //     break;
      //   case 15:
      //     price = 135;
      //     break;
      //   case 16:
      //     price = 145;
      //     break;
      //   case 17:
      //     price = 155;
      //     break;
      //   default:
      //     price = false;
      //     break;
      // }

      return price
    },
    gmapLocation() {
      var vm = this
      var locations = []
      var nearestlocation
      var stringlatlng =
        this.gmapvalue ||
        this.gmapvalue.lat.toString() + ',' + this.gmapvalue.lng.toString()
      // eslint-disable-next-line no-undef
      var service = new google.maps.DistanceMatrixService()
      var origins = vm.branchlocation.map((el) => el.lat_long)

      service.getDistanceMatrix(
        {
          origins,
          destinations: [stringlatlng],
          travelMode: 'DRIVING',
          region: 'TH',

          drivingOptions: {
            departureTime: new Date(),
            trafficModel: 'optimistic'
          }
        },
        callback
      )
      function callback(response, status) {
        if (status == 'OK') {
          var bodyjson = response
          for (var i = 0; i < bodyjson.rows.length; i++) {
            var row = bodyjson.rows[i].elements[0].distance

            try {
              locations.push({
                name: vm.branchlocation[i].name,
                distance: parseFloat((row.value / 1000).toFixed(2)),
                pictureurl: vm.branchlocation[i].pictureurl
              })
            } catch (error) {
              console.error(error)
            }
          }

          locations.sort((a, b) => {
            var x = a.distance
            var y = b.distance
            return x < y ? -1 : x > y ? 1 : 0
          })

          nearestlocation = locations[0]
          vm.shippingAddress = response.destinationAddresses[0]
          vm.placesinfo = response.destinationAddresses[0]
          vm.khaiwhandistance = nearestlocation
          var shippingprice = vm.calshippingpricekaiwan(
            nearestlocation.distance,
            vm.totalPrice
          )
          vm.ableToShipping = shippingprice !== false
          vm.khaiwhanshippingprice = vm.ableToShipping ? shippingprice : 0

          if (nearestlocation) {
            vm.banktransferinfo_photo = nearestlocation.pictureurl
          } else if (vm.branchlocation && vm.branchlocation.length > 0) {
            vm.banktransferinfo_photo = vm.branchlocation[0].pictureurl
          } else {
            vm.banktransferinfo_photo = vm.mainBankTransferInfoPhoto
          }
          vm.khaiwhanselectedbank = vm.khaiwhanbank.find(
            (el) => el.ref == nearestlocation.name
          )
        } else {
          // 400
        }
      }
    },
    async checkOrderStatus() {
      //   var total = numeral(0.01).format("0.00");
      var total = numeral(this.totalPrice).format('0.00')
      var response = await axios.get(
        config.getConfig('serverUrl') +
          `gbcompletedwithrefnoverify?referenceNo=${this.referenceNo}&pageid=${this.pageid}&userid=${this.userid}&amount=${total}`
      )
      return response
    },
    requestQrCode() {
      var vm = this
      return new Promise((resolve, reject) => {
        var data = new FormData()
        var total = numeral(vm.totalPrice).format('0.00')
        // var total = numeral(0.01).format("0.00");
        vm.referenceNo = moment().format('x')

        data.append(
          'token',
          vm.pageProfile.gbprime_token
          // "PUD9omECXQTwqePYfQzTS+S+lExcJJVNe3Ov0G2swnmSLml8MW3Ws6AKuvavsm5ydRzYSXuTFhyW1Q52EqXQUATUTsI+i1yCX7HDupxf7UEt3FBpQIKtTpo2bf0GetHO63MLQuHRsGk5cCe3H/Rw+NyC/7+HkSScuRlx5ikPosSJ9aeG"
        )
        data.append('amount', total)
        data.append('referenceNo', vm.referenceNo)
        data.append('detail', '-')
        data.append('customerName', vm.customerName)
        data.append(
          'backgroundUrl',
          `https://zwizai.herokuapp.com/gbcompletedcartwithrefno?referenceNo=${vm.referenceNo}&amount=${total}&userid=${vm.userid}&pageid=${vm.pageid}`
        )

        var xhr = new XMLHttpRequest()
        // xhr.withCredentials = true;

        xhr.addEventListener('readystatechange', function () {
          if (this.readyState === 4) {
            if (this.status == 200) {
              var arrayBuffer = this.response // Note: not oReq.responseText
              if (arrayBuffer) {
                resolve(new Uint8Array(arrayBuffer))
              } else {
                reject()
              }
              //
            } else {
              reject()
            }
          }
        })

        xhr.open('POST', 'https://api.gbprimepay.com/gbp/gateway/qrcode')
        xhr.responseType = 'arraybuffer'
        // xhr.setRequestHeader("Content-Type", "application/json");

        xhr.send(data)
      })
    },
    async submitOrder() {
      if (this.isEmptyShoppingCart) {
        return false
      }

      var total = this.total + this.additionalproduct_charge
      if (this.shippingType) {
        total += this.shippingType.value
      }
      if (this.chooseShippingType == 'pickup') {
        this.shippingAddress = 'รับที่ร้าน'
      }
      let data = {
        amount: this.totalPrice.toFixed(2).toString().replace('.', ''),
        pageid: this.pageid,
        userid: this.userid,
        app: this.app,
        name: this.customerName,
        address: this.shippingAddress,
        phone: this.customerPhone,
        nameaddress:
          this.customerName +
          ' , ' +
          this.shippingAddress +
          ' , ' +
          this.customerPhone,
        shippingtype: this.shippingType ? this.shippingType.type : null,
        note: this.paymentSlipImage,
        remark: this.remark,
        payment: this.transferType == 'qrcode' ? 'qrcode' : null,
        shippingcharge: (
          (this.shippingType ? this.shippingType.value : 0) +
          this.additionalproduct_charge
        )
          .toFixed(2)
          .toString()
          .replace('.', ''),
        total: total.toFixed(2).toString().replace('.', '')
      }
      if (this.voucher) {
        data.promocode = this.voucher.promocode
      }
      if (this.transferType == 'qrcode') {
        data.paiddate = moment()
        data.transactionid = this.referenceNo
      } else {
        data.paiddate = moment(`${this.paiddate} ${this.paidtime}`)
      }
      data.cart_ids = this.$store.state.cart_ids || []

      let url = config.getConfig('serverUrl') + 'banktransfernotify'
      if (this.sessiontoken != null || this.sessiontoken != '') {
        url += '?sessiontoken=' + this.sessiontoken
      }

      try {
        var response = await axios.post(url, data)

        // JSON responses are automatically parsed.
        response = response.data
        if (response.responsecode == 200) {
          this.isCompleted = true
          await this.$store.dispatch('deleteAllItemsInCart')
          // eslint-disable-next-line
          if (this.$liff.isInClient()) {
            // eslint-disable-next-line no-undef
            // if(data.from != "livechat") {

            //   }
            await this.$liff.sendMessages([
              {
                type: 'text',
                text: 'Order: ' + response.orderid
              }
            ])
            // eslint-disable-next-line no-undef
            await this.$liff.closeWindow()
          } else {
            // eslint-disable-next-line no-undef
            MessengerExtensions.requestCloseBrowser(
              function success() {},
              function error() {
                window.close()
              }
            )
          }
        } else if (response.responsecode == 201) {
          this.isCompleted = true
          await this.$store.dispatch('deleteAllItemsInCart')
          let url = '/ecommerce/' + this.pagename
          if (this.userid && this.userid != null && this.userid != '') {
            url += '?userid=' + this.userid
          }
          this.$router.push({ path: url })
        } else {
          await this.$swal({
            title: this.$t('Error'),
            text: this.$t('Something went wrong. Please try it again.'),
            type: 'error',
            confirmButtonText: this.$t('Confirm'),
            cancelButtonText: this.$t('Cancel'),
            reverseButtons: true
          })
        }
      } catch (error) {
        this.loading = false
        await this.$swal({
          title: this.$t('Error'),
          text: this.$t('Something went wrong. Please try it again.'),
          type: 'error',
          confirmButtonText: this.$t('Confirm'),
          cancelButtonText: this.$t('Cancel'),
          reverseButtons: true
        })
      }
    },
    async getQrCode() {
      var result = await this.$validator.validate()
      if (!result) {
        // do stuff if not valid.
        this.goToErrorInput()
        throw 400
      }

      try {
        var response = await this.requestQrCode()
        // console.log(response);
        var binary = response.reduce(
          (data, b) => (data += String.fromCharCode(b)),
          ''
        )
        this.qrimage = 'data:image/jpeg;base64,' + btoa(binary)
        var vm = this
        this.intervalQrCode = setInterval(async () => {
          vm.timer -= 1
          vm.isRequest = vm.timer % 5 == 0
          if (vm.timer == 0) {
            clearInterval(vm.intervalQrCode)
            await vm.$swal({
              title: vm.$t('Error'),
              text: vm.$t('Something went wrong. Please try it again.'),
              type: 'error',
              confirmButtonText: vm.$t('Confirm')
            })
            vm.showQrCode = false
            vm.timer = 300
          } else if (vm.timer % 5 == 0) {
            var response = await vm.checkOrderStatus()
            if (response.status == 200 && response.data.responsecode == 200) {
              if (response.data.data && response.data.data != null) {
                clearInterval(vm.intervalQrCode)

                vm.loading = true
                // console.log("submit");
                await vm.submitOrder()
                vm.loading = false

                vm.showQrCode = false
                vm.timer = 300
              }
            } else {
              clearInterval(vm.intervalQrCode)
              await vm.$swal({
                title: vm.$t('Error'),
                text: vm.$t('Something went wrong. Please try it again.'),
                type: 'error',
                confirmButtonText: vm.$t('Confirm')
              })
              vm.showQrCode = false
              vm.timer = 300
            }
          }
        }, 1000)
      } catch (error) {
        throw error
      }
    },
    getUserDetail: function () {
      let vm = this
      return new Promise((resolve, reject) => {
        axios
          .get(
            config.getConfig('serverUrl') +
              'lastorderaddress?pageid=' +
              vm.pageid +
              '&userid=' +
              vm.userid
          )
          .then((response) => {
            // JSON responses are automatically parsed.
            response = response.data
            if (response.responsecode == 200) {
              if (response.data) {
                var gmapregex =
                  /https\:\/\/www\.google\.com\/maps\?\=(\d)+(\.(\d)+)?\,(\d)+(\.(\d)+)?/gm
                if (gmapregex.test(response.data.address)) {
                  var coords = response.data.address.match(gmapregex)[0]
                  coords = coords.split('@')[1].split(',')
                  vm.lastordercoords = { lat: coords[0], lng: coords[1] }
                }
                resolve(response.data)
              } else {
                reject()
              }
            } else {
              reject()
              // console.log(response);
            }
          })
      })
    },
    openModal: function () {
      this.showTerm = true
      let vm = this
      window.location.hash = '#modal-open'
      window.onpopstate = function () {
        if (location.hash == '#modal-open') {
          //   console.log("test");
        } else {
          vm.showTerm = false
        }
      }
    },
    close: function () {
      var vm = this
      if (window.history.length == 0) {
        vm.showTerm = false
      } else {
        window.history.back()
      }
    },
    getTransferDetail: async function () {
      let vm = this
      var response = await axios.get(
        config.getConfig('serverUrl') + 'banktransferinfo?pageid=' + vm.pageid
      )
      // JSON responses are automatically parsed.
      response = response.data
      if (response.responsecode == 200) {
        vm.banktransferinfo = response.banktransferinfo
        vm.banktransferinfo_photo = response.banktransferinfo_photo
        vm.mainBankTransferInfoPhoto = response.banktransferinfo_photo
      } else {
        //
      }
    },
    async qrHandleSubmit() {
      try {
        await this.getQrCode()
        this.showQrCode = true
      } catch (error) {
        // console.log(error);
      }
    },
    handleSubmit: function () {
      let vm = this
      vm.$validator.validate().then((result) => {
        if (!result) {
          // do stuff if not valid.
          vm.goToErrorInput()
          return false
        }
        if (vm.isEmptyShoppingCart) {
          return false
        }
        vm.loading = true
        var total = vm.total + vm.additionalproduct_charge
        if (vm.shippingType) {
          total += vm.shippingType.value
        }
        total += vm.customShippingPrice
        var payment
        if (vm.transferType) {
          payment = vm.transferType
        } else {
          payment = null
        }
        var gmapregex =
          /https\:\/\/www\.google\.com\/maps\?\=(\d)+(\.(\d)+)?\,(\d)+(\.(\d)+)?/gm
        var shippingAddress
        if (vm.chooseShippingType == 'pickup') {
          vm.shippingAddress = 'รับที่ร้าน'
          shippingAddress = 'รับที่ร้าน'
        } else {
          if (vm.shippingAddress) {
            if (gmapregex.test(vm.shippingAddress)) {
              vm.shippingAddress = vm.shippingAddress
                .replace(gmapregex, '')
                .replace('\n', '')
            }
            shippingAddress =
              vm.shippingAddress +
              '\nhttps://www.google.com/maps?q=' +
              vm.gmapvalue.lat.toString() +
              ',' +
              vm.gmapvalue.lng.toString()
          }
        }
        let data = {
          amount: vm.totalPrice.toFixed(2).toString().replace('.', ''),
          pageid: vm.pageid,
          userid: vm.userid,
          app: vm.app,
          name: vm.customerName,
          address: vm.shippingAddress,
          phone: vm.customerPhone,
          payment: payment,
          nameaddress:
            vm.customerName +
            ' , ' +
            shippingAddress +
            ' , ' +
            vm.customerPhone,
          shippingtype: vm.khaiwhandistance.name,
          note: vm.paymentSlipImage,
          remark: vm.remark,
          shippingcharge: vm.customShippingPrice
            .toFixed(2)
            .toString()
            .replace('.', ''),
          total: total.toFixed(2).toString().replace('.', '')
        }
        if (this.voucher) {
          data.promocode = this.voucher.promocode
        }
        if (this.isBearhouse) {
          data.shippingtype = 'other_charge'
          data.shippingcharge = vm.bearhouseshippingprice
            .toFixed(2)
            .toString()
            .replace('.', '')
          data.total = (vm.total + vm.bearhouseshippingprice)
            .toFixed(2)
            .toString()
            .replace('.', '')
        }
        data.cart_ids = this.$store.state.cart_ids || []
        let url = config.getConfig('serverUrl') + 'banktransfernotify'
        if (vm.sessiontoken != null || vm.sessiontoken != '') {
          url += '?sessiontoken=' + vm.sessiontoken
        }
        if (vm.$route.query.from) {
          data.from = vm.$route.query.from
        } else {
          try {
            var device = vm.$liff.getOS()
            var version = vm.$liff.getVersion()
            vm.$liff.ready.then(() => {
              if (
                vm.userid.indexOf('__') != -1 &&
                device &&
                version &&
                !vm.$liff.isInClient()
              ) {
                data.from = 'livechat'
              }
            })
          } catch (error) {
            // eslint-disable-next-line
            console.log(error)
          }
        }
        axios
          .post(url, data)
          .then((response) => {
            // JSON responses are automatically parsed.
            response = response.data
            if (response.responsecode == 200) {
              vm.isCompleted = true
              vm.$store.dispatch('deleteAllItemsInCart')
              // eslint-disable-next-line
              if (vm.$liff.isInClient()) {
                // eslint-disable-next-line no-undef
                vm.$liff
                  .sendMessages([
                    {
                      type: 'text',
                      text: 'Order: ' + response.orderid
                    }
                  ])
                  .then(() => {})
                // eslint-disable-next-line no-undef
                vm.$liff.closeWindow()
              } else {
                // eslint-disable-next-line no-undef
                MessengerExtensions.requestCloseBrowser(
                  function success() {},
                  function error() {
                    window.close()
                  }
                )
              }
            } else if (response.responsecode == 400) {
              vm.$swal({
                title: vm.$t('Error'),
                text: vm.$t(response.reason),
                type: 'error',
                confirmButtonText: vm.$t('Confirm'),
                cancelButtonText: vm.$t('Cancel'),
                reverseButtons: true
              })
            } else if (response.responsecode == 201) {
              vm.isCompleted = true
              vm.$store.dispatch('deleteAllItemsInCart')
              let url = '/ecommerce/' + vm.pagename
              if (vm.userid && vm.userid != null && vm.userid != '') {
                url += '?userid=' + vm.userid
              }
              vm.$router.push({ path: url })
            } else {
              vm.$swal({
                title: vm.$t('Error'),
                text: vm.$t('Something went wrong. Please try it again.'),
                type: 'error',
                confirmButtonText: vm.$t('Confirm'),
                cancelButtonText: vm.$t('Cancel'),
                reverseButtons: true
              })
            }
            vm.loading = false
          })
          .catch(() => {
            vm.loading = false
            vm.$swal({
              title: vm.$t('Error'),
              text: vm.$t('Something went wrong. Please try it again.'),
              type: 'error',
              confirmButtonText: vm.$t('Confirm'),
              cancelButtonText: vm.$t('Cancel'),
              reverseButtons: true
            })
          })
      })
    },

    getUserCart: function () {
      let vm = this
      return new Promise((resolve, reject) => {
        axios
          .get(
            config.getConfig('serverUrl') +
              'usercart?pageid=' +
              vm.pageid +
              '&userid=' +
              vm.userid
          )
          .then((response) => {
            // JSON responses are automatically parsed.
            response = response.data
            if (response.responsecode == 200) {
              vm.banktransferinfo = response.banktransferinfo
              vm.banktransferinfo_photo = response.banktransferinfo_photo
              // vm.$store.dispatch('setCart',response.cartarray)
              vm.$store.commit('SET_CART_ID', response.cart_ids || [])
              if (response.cartarray) {
                if (response.cartarray.length == 0) {
                  vm.isEmptyShoppingCart = true
                }
                var product_id_list = []
                var products = []

                $.each(response.cartarray, function (index, val) {
                  product_id_list.push(val.productid)

                  if (vm.products[val.productid]) {
                    var stock = vm.products[val.productid].productstock
                    var option = stock.find(function (el) {
                      return el[1] == val.option
                    })
                  }
                  products.push({
                    photourl: val.photourl,
                    quantity: val.quantity,
                    name: val.name,
                    option: val.option,
                    id: val.productid,
                    price: parseFloat(val.price),
                    discountprice: parseFloat(val.discountprice),
                    optionDetail: option,
                    categoryid: val.categoryid,
                    cart_remark: val.cart_remark
                  })
                })

                if (products.length > 0) {
                  for (let index = 0; index < products.length; index++) {
                    vm.$store.dispatch('addToCart', {
                      product: products[index]
                    })
                  }

                  let url =
                    config.getConfig('serverUrl') +
                    'productbundle?productid=' +
                    product_id_list.join(',')
                  axios.get(url).then((response) => {
                    response = response.data
                    if (
                      response.responsecode == 200 &&
                      response.productbundlelist.length > 0
                    ) {
                      vm.$store.commit(
                        'UPDATE_BUNDLE_CART',
                        response.productbundlelist
                      )
                    }
                  })
                }

                vm.additionalproduct_charge = parseFloat(
                  response.additionalproduct_charge
                )
                vm.ems_charge = parseFloat(response.ems_charge)
                vm.normal_charge = parseFloat(response.normal_charge)
                vm.kerry_charge = parseFloat(response.kerry_charge)
                vm.total = parseFloat(response.total)
                vm.totalincludediscount = parseFloat(
                  response.totalincludediscount
                )
                vm.discount = parseFloat(response.discount)

                vm.shippinglist = response.shippinglist
              }
              resolve()
            } else {
              // console.log(response);
              reject()
            }
          })
      })
    },
    goToShop: function () {
      let vm = this
      let url = '/ecommerce/' + vm.pagename
      if (vm.userid && vm.userid != null && vm.userid != '') {
        url += '?userid=' + vm.userid
        if (
          vm.sessiontoken &&
          vm.sessiontoken != null &&
          vm.sessiontoken != ''
        ) {
          url += '&sessiontoken=' + vm.sessiontoken
        }
      }
      vm.$router.push({ path: url })
    },
    getProducts: function () {
      let vm = this
      return new Promise((resolve, reject) => {
        var data = {
          pageid: vm.pageid
        }
        if (
          vm.pageProfile &&
          vm.pageProfile.useketshop == true &&
          vm.pageProfile.ketshop_api_key &&
          vm.pageProfile.ketshop_api_secret
        ) {
          data['ketshop_api_key'] = vm.pageProfile.ketshop_api_key
          data['ketshop_api_secret'] = vm.pageProfile.ketshop_api_secret
        }
        axios
          .get(config.getConfig('serverUrl') + 'products', {
            params: data
          })
          .then((response) => {
            // JSON responses are automatically parsed.
            response = response.data
            if (response.responsecode == 200) {
              vm.products = {}
              $.each(response.productlist, function (index, val) {
                response.productlist[index].price = parseFloat(
                  response.productlist[index].price
                )
                response.productlist[index].discountprice = parseFloat(
                  response.productlist[index].discountprice
                )
                response.productlist[index].isOutOfStock = false

                if (response.productlist[index].productstock.length > 0) {
                  var haveStock = false
                  $.each(val.productstock, function (pindex, pval) {
                    if (
                      parseInt(
                        response.productlist[index].productstock[pindex][2]
                      ) > 0
                    ) {
                      haveStock = true
                    }

                    var price = 0
                    var discount = 0

                    if (pval[3] == null && pval[4] == null) {
                      price = parseFloat(val.price)
                      discount = parseFloat(val.discountprice)
                    } else {
                      if (pval[3] == null) {
                        price = parseFloat(val.price)
                      } else {
                        price = parseFloat(
                          response.productlist[index].productstock[pindex][3]
                        )
                      }

                      if (pval[4] == null) {
                        discount =
                          response.productlist[index].productstock[pindex][3]
                      } else {
                        discount = parseFloat(
                          response.productlist[index].productstock[pindex][4]
                        )
                      }
                    }

                    response.productlist[index].productstock[pindex][3] = price

                    response.productlist[index].productstock[pindex][4] =
                      discount
                  })

                  if (!haveStock) {
                    response.productlist[index].isOutOfStock = true
                  }
                } else {
                  response.productlist[index].isOutOfStock = true
                }
                if (val) {
                  vm.products[val.id] = val
                }
              })

              resolve()
            } else {
              // console.log(response);
              reject()
            }
          })
      })
    }
  }
}
</script>
